import React from 'react'

import { BaseView } from '@/components/base'
import { useTheme } from '@/hooks/useTheme'

interface SkeletonListTemplateProps {
  sizeList: number
  containerStyles?: React.CSSProperties
}

export const SkeletonListTemplate: React.FC<SkeletonListTemplateProps> = ({
  sizeList,
  containerStyles,
}) => {
  const theme = useTheme()

  return (
    <BaseView gap={12} style={containerStyles}>
      {Array.from({ length: sizeList }).map((_, index) => (
        <BaseView
          key={index}
          row
          align="center"
          gap={16}
          px={12}
          py={16}
          bgColor="background.secondaryGray"
          rounded={16}
          style={{
            marginHorizontal: '12px',
          }}
          className="animate-pulse"
        >
          {/* Avatar skeleton */}
          <div
            style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: theme.colors.background.secondaryGrayOpacity01,
            }}
          />

          {/* Content skeleton */}
          <BaseView flex={1} gap={8}>
            {/* Top row skeleton */}
            <BaseView
              row
              justify="space-between"
              align="center"
              fullWidth
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <div
                style={{
                  width: '120px',
                  height: '16px',
                  backgroundColor:
                    theme.colors.background.secondaryGrayOpacity01,
                  borderRadius: '8px',
                }}
              />
              <div
                style={{
                  width: '80px',
                  height: '16px',
                  backgroundColor:
                    theme.colors.background.secondaryGrayOpacity01,
                  borderRadius: '8px',
                }}
              />
            </BaseView>

            {/* Bottom row skeleton */}
            <div
              style={{
                width: '100px',
                height: '14px',
                backgroundColor: theme.colors.background.secondaryGrayOpacity01,
                borderRadius: '8px',
              }}
            />
          </BaseView>
        </BaseView>
      ))}
    </BaseView>
  )
}
